import { Box, Stack } from "@mui/system";
import BLDWebsiteIncomeCard from "./BLDWebsiteIncomeCard";
import {
  formatCurrency,
  formatDate,
  formatPercent,
} from "../../../../../helpers/roundFunctions";
import { spacing } from "../../../../../../../../../../assets/styles/tokens";

const BLDWebsiteIncome = ({ sortedData }: any) => {
  return (
    <>
      <Box sx={{ mt: "-" + spacing.Spacing.md.$value }}>
        <Stack spacing={2}>
          {sortedData?.map((item: any, index: number) => (
            <BLDWebsiteIncomeCard
              key={index}
              date={formatDate(item.start_of_week || item.date || item.month)}
              totalIncome={formatCurrency(item.total_income_dollar)}
              cpa={formatCurrency(item.cpa_income_dollar)}
              cpaPercentage={formatPercent(
                item.cpa_income_dollar / item.total_income_dollar,
              )}
              cpaColor="success"
              rs={formatCurrency(item.rs_income_dollar)}
              rsPercentage={formatPercent(item.rs_perc_from_total_income)}
              rsColor="error"
              profit={formatCurrency(item.profit)}
            />
          ))}
        </Stack>
      </Box>
    </>
  );
};

export default BLDWebsiteIncome;
